(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[459],{

/***/ 6429:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/login",
      function () {
        return __webpack_require__(8664);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _atoms_Input__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3099);
/* harmony import */ var _atoms_Label__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2655);






var InputWithLabel = function(_param) {
    var className = _param.className, labelText = _param.labelText, _varient = _param.varient, varient = _varient === void 0 ? "normal" : _varient, type = _param.type, name = _param.name, placeholder = _param.placeholder, handleFocus = _param.handleFocus, handleBlur = _param.handleBlur, classForInput = _param.classForInput, classForLabel = _param.classForLabel, disabled = _param.disabled, onChange = _param.onChange, _isRequired = _param.isRequired, isRequired = _isRequired === void 0 ? false : _isRequired, value = _param.value, properties = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className",
        "labelText",
        "varient",
        "type",
        "name",
        "placeholder",
        "handleFocus",
        "handleBlur",
        "classForInput",
        "classForLabel",
        "disabled",
        "onChange",
        "isRequired",
        "value"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "".concat(className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Label__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                className: "text-gray-900 text-sm font-normal ".concat(classForLabel),
                children: labelText
            }),
            isRequired && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "text-red-400",
                children: "*"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Input__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                className: "border border-gray-200 rounded-lg  w-full mt-2 ".concat(classForInput, " "),
                value: value,
                type: type,
                name: name,
                placeholder: placeholder,
                varient: varient,
                onFocus: handleFocus,
                onBlur: handleBlur,
                disabled: disabled,
                onChange: onChange
            }, properties))
        ]
    });
};
InputWithLabel.propTypes = {
    varient: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    children: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().node),
    labelText: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string.isRequired),
    type: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    name: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    placeholder: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    handleFocus: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().func),
    handleBlur: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().func),
    classForInput: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    classForLabel: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (InputWithLabel);


/***/ }),

/***/ 1488:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var _atoms_Text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3179);





var Toaster = function(param) {
    var type = param.type, toasterImgSrc1 = param.toasterImgSrc1, toasterImgAlt1 = param.toasterImgAlt1, toasterHeading = param.toasterHeading, _imgSrc2 = param.imgSrc2, imgSrc2 = _imgSrc2 === void 0 ? "/images/x.svg" : _imgSrc2, _imgAlt2 = param.imgAlt2, imgAlt2 = _imgAlt2 === void 0 ? "x" : _imgAlt2, className = param.className, _toasterHeadingClass = param.toasterHeadingClass, toasterHeadingClass = _toasterHeadingClass === void 0 ? "text-gray-800 font-medium " : _toasterHeadingClass, _basePath = param.basePath, basePath = _basePath === void 0 ? "/app" : _basePath;
    var toasterType = {
        success: "rounded flex items-center mx-auto bg-green-600 pl-5 w-[278px] pr-3 h-[52px]",
        danzer: "rounded flex items-center gap-x-2.5 mx-auto bg-red-400 pl-5 w-[154px] h-[52px]",
        incorrectOtp: "rounded-lg flex items-center justify-between m-auto bg-red-50 border border-red-400 px-[18px] w-[204px] h-[52px]",
        otpSuccess: "flex items-center px-4 w-[295px] h-[50px] bg-white border border-gray-200 shadow-sm rounded-lg text-sm font-normal text-green-600 m-auto",
        success2: "flex items-center px-2.5 fit-content h-10 bg-white border border-gray-200 shadow-sm rounded-lg text-sm font-normal text-gray-600 m-auto",
        error: "flex fit-content items-center px-2.5 h-10 bg-white border border-gray-200 shadow-sm rounded-lg text-sm font-normal text-gray-600 m-auto"
    };
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), hide = ref[0], setHide = ref[1];
    var handleClick = function() {
        setHide(false);
    };
    return hide && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "absolute left-0 right-0 z-50 mt-[10px] ".concat(toasterType[type], " ").concat(className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                src: "".concat(basePath).concat(toasterImgSrc1),
                alt: toasterImgAlt1,
                width: "24",
                height: "24"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                className: "".concat(toasterHeadingClass),
                children: toasterHeading
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                src: "".concat(basePath).concat(imgSrc2),
                alt: "".concat(imgAlt2),
                width: "24",
                height: "24",
                className: "cursor-pointer",
                onClick: handleClick
            })
        ]
    });
};
Toaster.propTypes = {
    width: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    height: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    type: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    toasterImgSrc1: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    toasterImgAlt1: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    toasterHeading: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    imgSrc2: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    imgAlt2: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    toasterHeadingClass: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (Toaster);


/***/ }),

/***/ 8664:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ login; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./services/helper-function.service.js + 224 modules
var helper_function_service = __webpack_require__(5747);
// EXTERNAL MODULE: ./services/identity.service.js + 3 modules
var identity_service = __webpack_require__(3275);
// EXTERNAL MODULE: ./services/user.service.js
var user_service = __webpack_require__(1005);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./atoms/Anchor.js
var Anchor = __webpack_require__(2477);
// EXTERNAL MODULE: ./atoms/Button.js
var Button = __webpack_require__(2887);
// EXTERNAL MODULE: ./atoms/Heading.js
var Heading = __webpack_require__(4010);
// EXTERNAL MODULE: ./atoms/Input.js
var Input = __webpack_require__(3099);
// EXTERNAL MODULE: ./atoms/Label.js
var Label = __webpack_require__(2655);
// EXTERNAL MODULE: ./atoms/Text.js
var Text = __webpack_require__(3179);
// EXTERNAL MODULE: ./molecules/InputWithLabel.js
var InputWithLabel = __webpack_require__(9978);
;// CONCATENATED MODULE: ./components/Login/Login.js



















var timerId;
var Login = function(param) {
    var className = param.className, _basePath = param.basePath, basePath = _basePath === void 0 ? "/app" : _basePath, setShowAlert = param.setShowAlert, setShowError = param.setShowError;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(false), hasFocus = ref[0], setFocus = ref[1];
    var ref1 = (0,react.useState)(false), value = ref1[0], setValue = ref1[1];
    var ref2 = (0,react.useState)(false), isOtpSent = ref2[0], setOtpSent = ref2[1];
    var ref3 = (0,react.useState)(false), focused = ref3[0], setFocused = ref3[1];
    var ref4 = (0,react.useState)(false), error = ref4[0], setError = ref4[1];
    var ref5 = (0,react.useState)(0), timerValue = ref5[0], setTimerValue = ref5[1];
    var ref6 = (0,react.useState)(""), otpValue = ref6[0], setOtpValue = ref6[1];
    var ref7 = (0,react.useState)(true), disableVerify = ref7[0], setDisableVerify = ref7[1];
    var ref8 = (0,react.useState)(false), showResend = ref8[0], setShowResend = ref8[1];
    var ref9 = (0,react.useState)(false), isLoading = ref9[0], setIsLoading = ref9[1];
    var ref10 = (0,react.useState)(""), errorMessage = ref10[0], setErrorMessage = ref10[1];
    var ref11 = (0,react.useState)(false), isEmailValid = ref11[0], setIsEmailValid = ref11[1];
    var emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    var ref12 = (0,react.useState)(""), otpDisplayValue = ref12[0], setOtpDisplayValue = ref12[1];
    var ref13 = (0,react.useState)("".concat("https://dbdaddy.dev/api", "/auth/google/Login")), googleRedirectUrl = ref13[0], setGoogleRedirectUrl = ref13[1];
    var query = (0,next_router.useRouter)().query;
    var redirectUrl = query;
    (0,react.useEffect)(function() {
        setGoogleRedirectUrl("".concat("https://dbdaddy.dev/api", "/auth/google/Login?from=").concat(redirectUrl.from));
    }, []);
    var emailValidation = function() {
        if (value) {
            if (emailRegex.test(value)) {
                setIsEmailValid(true);
                setErrorMessage("");
            } else {
                setIsEmailValid(false);
                setErrorMessage("Please enter valid email");
            }
        } else {
            setErrorMessage("");
        }
    };
    (0,react.useEffect)(function() {
        emailValidation();
    }, [
        value
    ]);
    var handleFocus = function() {
        setFocus(true);
    };
    var sendOtp = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e) {
            var response, ref, sendOtpError;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (isEmailValid) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        setIsLoading(true);
                        e.preventDefault();
                        _ctx.next = 6;
                        return (0,user_service/* signInWithEmail */.Ry)(value);
                    case 6:
                        response = _ctx.sent;
                        ref = (0,helper_function_service/* handleApiResponse */.Ro)(response, "Otp generation failure"), sendOtpError = ref.apiError;
                        if (!sendOtpError.length) {
                            _ctx.next = 12;
                            break;
                        }
                        setErrorMessage("Unable to send OTP. Please try again.");
                        setIsLoading(false);
                        return _ctx.abrupt("return");
                    case 12:
                        setOtpSent(true);
                        setTimerValue(60);
                        setShowResend(false);
                        setShowAlert(true);
                        setIsLoading(false);
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function sendOtp(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var resendOtpForSigin = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e) {
            var response, ref, resendOtpError;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setIsLoading(true);
                        e.preventDefault();
                        setOtpValue("");
                        _ctx.next = 5;
                        return (0,user_service/* resendOtp */.Rv)(value);
                    case 5:
                        response = _ctx.sent;
                        ref = (0,helper_function_service/* handleApiResponse */.Ro)(response, "Resend Otp generation failure"), resendOtpError = ref.apiError;
                        if (!resendOtpError.length) {
                            _ctx.next = 11;
                            break;
                        }
                        setErrorMessage("Unable to send OTP. Please try again.");
                        setIsLoading(false);
                        return _ctx.abrupt("return");
                    case 11:
                        setOtpSent(true);
                        setTimerValue(60);
                        setShowResend(false);
                        setShowAlert(true);
                        setIsLoading(false);
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function resendOtpForSigin(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var verifyLoginOtp = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e) {
            var ref, response, ref1, details, verifyOtpError, userDetailresponse, ref2, company, role, id, email, fullName, isSample, authDetails;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        ;
                        setIsLoading(true);
                        e.preventDefault();
                        _ctx.next = 6;
                        return (0,user_service/* verifyOtp */.Mu)({
                            email: value,
                            otp: parseInt(otpValue)
                        });
                    case 6:
                        response = _ctx.sent;
                        ref1 = (0,helper_function_service/* handleApiResponse */.Ro)(response, "Otp verification failure"), details = ref1.details, verifyOtpError = ref1.apiError;
                        if (!verifyOtpError.length) {
                            _ctx.next = 13;
                            break;
                        }
                        setErrorMessage("Incorrect OTP! Please enter valid OTP.");
                        setShowError(true);
                        setIsLoading(false);
                        return _ctx.abrupt("return");
                    case 13:
                        _ctx.next = 15;
                        return (0,user_service/* authenticateUser */.So)(details.token);
                    case 15:
                        userDetailresponse = _ctx.sent;
                        ref2 = userDetailresponse === null || userDetailresponse === void 0 ? void 0 : (ref = userDetailresponse.data) === null || ref === void 0 ? void 0 : ref.entity, company = ref2.company, role = ref2.role, id = ref2.id, email = ref2.email, fullName = ref2.fullName, isSample = ref2.isSample;
                        setErrorMessage("");
                        setIsLoading(false);
                        authDetails = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, details), {
                            company: company,
                            role: role,
                            id: id,
                            email: email,
                            fullName: fullName,
                            isSample: isSample
                        });
                        if (Object.keys(redirectUrl).length > 0) {
                            (0,identity_service/* setAuth */.QV)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, authDetails), {
                                isSample: false
                            }));
                        } else {
                            (0,identity_service/* setAuth */.QV)((0,_object_spread/* default */.Z)({}, authDetails));
                        }
                        if (company) {
                            _ctx.next = 28;
                            break;
                        }
                        if (!(Object.keys(redirectUrl).length > 0)) {
                            _ctx.next = 24;
                            break;
                        }
                        return _ctx.abrupt("return", router.push("/db-view/details?from=".concat(redirectUrl.from)));
                    case 24:
                        localStorage.setItem("showSamplePopUp", true);
                        router.push("/db-view/details");
                        _ctx.next = 31;
                        break;
                    case 28:
                        if (!(Object.keys(redirectUrl).length > 0)) {
                            _ctx.next = 30;
                            break;
                        }
                        return _ctx.abrupt("return", router.push("".concat(redirectUrl.from)));
                    case 30:
                        router.push("/db-view/".concat(details.projectId));
                    case 31:
                        _ctx.next = 36;
                        break;
                    case 33:
                        _ctx.prev = 33;
                        _ctx.t0 = _ctx["catch"](0);
                        console.log("something went wrong", _ctx.t0);
                    case 36:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    33
                ]
            ]);
        }));
        return function verifyLoginOtp(e) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        setTimeout(function() {
            if (timerValue == 0) {
                setShowResend(true);
                return clearTimeout(timerId);
            }
            setTimerValue(timerValue - 1);
        }, 1000);
    }, [
        timerValue
    ]);
    var onChangeOtpHandler = function(e) {
        var input = e.target.value.split(" - ").join("");
        var inputLength = input.length;
        var insertedValue = input[inputLength - 1];
        if (inputLength <= 4) {
            if (inputLength === 4) {
                setDisableVerify(false);
            } else {
                setDisableVerify(true);
            }
        } else if (inputLength === 4) {
            setDisableVerify(true);
        } else {
            return;
        }
        if (!isNaN(Number(insertedValue)) || inputLength === 0) {
            setOtpValue(input);
            var otp = input.split("").join(" - ");
            setOtpDisplayValue(otp);
        }
    };
    var resetLoginForm = function() {
        setValue("");
        setError("");
        setIsEmailValid(false);
        setDisableVerify(false);
        setOtpDisplayValue("");
        setOtpValue("");
        setOtpSent(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-[390px] bg-white border border-gray-200 rounded-lg shadow-sm px-8 py-9 relative ".concat(className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-center absolute -top-16 left-1/2 transform -translate-x-1/2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: "".concat(basePath, "/images/logo-dbdaddy.svg"),
                    width: "100",
                    height: "39",
                    alt: "logo"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                className: "text-gray-700 font-semibold text-center",
                type: "h3",
                children: "Sign In"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                className: "pb-6 pt-9 relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Label/* default */.Z, {
                        className: "text-sm font-normal leading-5 text-gray-900",
                        children: "Email"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-[320px] h-11 relative mt-2 ".concat(className),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                className: "w-full h-full border rounded-lg focus:outline-none placeholder-gray-500 text-sm ".concat(hasFocus ? "bg-white border-purple-700 pl-4 text-gray-800" : "bg-gray-60 border border-gray-200 text-gray-70 ".concat(!value ? "pl-12" : "pl-4"), " ").concat(isOtpSent && "cursor-not-allowed"),
                                onFocus: handleFocus,
                                onBlur: function() {
                                    setFocus(false);
                                },
                                onChange: function(e) {
                                    return setValue(e.target.value);
                                },
                                placeholder: "".concat(hasFocus ? "" : "Enter your email"),
                                type: "email",
                                required: true,
                                disabled: isOtpSent,
                                value: value || ""
                            }),
                            !hasFocus && !value && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "absolute top-3 left-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: "".concat(basePath, "/images/sms.svg"),
                                    alt: "email",
                                    width: "18",
                                    height: "18"
                                })
                            })
                        ]
                    }),
                    isOtpSent && /*#__PURE__*/ (0,jsx_runtime.jsx)(InputWithLabel/* default */.Z, {
                        className: "mt-3",
                        classForInput: "".concat(focused ? error ? "bg-white border-red-400" : "bg-white border-purple-700" : "bg-gray-60 "),
                        labelText: "Verification code",
                        name: "otp",
                        placeholder: focused ? "" : "Enter 4 digit code",
                        type: "text",
                        value: otpDisplayValue,
                        varient: "normal",
                        handleFocus: function() {
                            setFocused(true);
                        },
                        handleBlur: function() {
                            setFocused(false);
                        },
                        // disabled={!isOtpSent}
                        onChange: onChangeOtpHandler
                    }),
                    errorMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-red-400 font-normal leading-5 text-xs pt-2",
                        children: errorMessage
                    }),
                    isOtpSent && !showResend && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        className: "text-gray-600 text-xxs text-right",
                        children: [
                            "Resend OTP in ",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "font-medium",
                                children: [
                                    timerValue,
                                    "s"
                                ]
                            })
                        ]
                    }),
                    isOtpSent && showResend && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        onClick: resendOtpForSigin,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                            className: "text-gray-600 text-xxs text-right hover:underline cursor-pointer",
                            children: [
                                "Resend OTP",
                                " "
                            ]
                        })
                    }),
                    !isOtpSent && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        id: "sendOtp",
                        className: "w-full mt-6  hover:bg-primary-1000  ".concat(isOtpSent && "bg-primary-100 text-primary-500 cursor-not-allowed"),
                        iconShow: false,
                        handleClick: isEmailValid && sendOtp,
                        varient: "secoundryBtn",
                        disabled: isOtpSent || !value,
                        isLoading: isLoading,
                        children: "Send OTP"
                    }),
                    isOtpSent && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        id: "verifyLoginOtp",
                        className: "w-full mt-6  ".concat(disableVerify && "bg-primary-100 text-primary-500 cursor-not-allowed"),
                        iconShow: false,
                        handleClick: verifyLoginOtp,
                        varient: "secoundryBtn",
                        isLoading: isLoading,
                        disabled: disableVerify,
                        children: "Verify"
                    })
                ]
            }),
            isOtpSent ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center text-center justify-center mt-3 cursor-pointer",
                onClick: resetLoginForm,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "mr-1 flex items-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "".concat(basePath, "/images/arrow-left.svg"),
                            width: "16",
                            height: "16",
                            alt: "arrow-left"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-gray-600 text-xs font-medium",
                            children: "Back to Sign In"
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "border-t border-gray-200 relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "bg-white text-xs leading-4 font-medium absolute right-2/4 -top-2 px-3 transform translate-x-4",
                        children: "OR"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Anchor/* default */.Z, {
                        href: googleRedirectUrl,
                        className: "flex items-center justify-center border border-gray-300 w-full py-3 rounded-lg bg-gray-60 mt-6 text-gray-700 text-sm font-medium",
                        id: "signInWithGoogle",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "mr-2 flex items-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: "".concat(basePath, "/images/Google.svg"),
                                    width: "24",
                                    height: "24",
                                    alt: "google"
                                })
                            }),
                            " ",
                            "Sign In with Google"
                        ]
                    })
                ]
            })
        ]
    });
};
Login.propTypes = {
    className: (prop_types_default()).string,
    basePath: (prop_types_default()).string,
    setShowAlert: (prop_types_default()).func,
    setShowError: (prop_types_default()).func
};
/* harmony default export */ var Login_Login = (Login);

// EXTERNAL MODULE: ./molecules/Toaster.js
var Toaster = __webpack_require__(1488);
;// CONCATENATED MODULE: ./Templates/UserLogin.js





var UserLogin = function(param) {
    var className = param.className, _height = param.height, height = _height === void 0 ? "h-full" : _height, _basePath = param.basePath, basePath = _basePath === void 0 ? "/app" : _basePath;
    var ref = (0,react.useState)(false), showAlert = ref[0], setShowAlert = ref[1];
    var ref1 = (0,react.useState)(false), showError = ref1[0], setShowError = ref1[1];
    (0,react.useEffect)(function() {
        setTimeout(function() {
            setShowError(false);
        }, 2000);
    }, [
        showError
    ]);
    (0,react.useEffect)(function() {
        setTimeout(function() {
            setShowAlert(false);
        }, 2000);
    }, [
        showAlert
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex justify-center w-full h-full ".concat(className),
        children: [
            showAlert && /*#__PURE__*/ (0,jsx_runtime.jsx)(Toaster/* default */.Z, {
                basePath: "",
                className: "bg-white",
                imgAlt2: "close-2",
                imgSrc2: "".concat(basePath, "/images/Close-2.svg"),
                toasterHeading: "OTP has been sent successfully",
                toasterHeadingClass: "text-green-600 ml-1 mr-2 text-sm font-normal",
                toasterImgAlt1: "close-circle",
                toasterImgSrc1: "".concat(basePath, "/images/alert-circle.svg"),
                type: "otpSuccess"
            }),
            showError && /*#__PURE__*/ (0,jsx_runtime.jsx)(Toaster/* default */.Z, {
                basePath: "",
                className: "",
                imgAlt2: "close-2",
                imgSrc2: "".concat(basePath, "/images/close-circle.svg"),
                toasterHeading: "Incorrent OTP",
                toasterHeadingClass: "ml-1 mr-3 text-sm font-normal",
                toasterImgAlt1: "close-circle",
                toasterImgSrc1: "".concat(basePath, "/images/alert-circle-red.svg"),
                type: "incorrectOtp"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full h-full flex justify-center items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Login_Login, {
                    basePath: basePath,
                    className: "",
                    setShowAlert: setShowAlert,
                    setShowError: setShowError
                })
            })
        ]
    });
};
UserLogin.propTypes = {
    className: (prop_types_default()).string,
    height: (prop_types_default()).string
};
/* harmony default export */ var Templates_UserLogin = (UserLogin);

;// CONCATENATED MODULE: ./pages/login.js


var login_Login = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-gray-50 flex justify-center items-center h-screen flex-col gap-8",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Templates_UserLogin, {})
    });
};
var __N_SSP = true;
/* harmony default export */ var login = (login_Login);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(6429); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);